import { Attributes, LookupBase, Misc } from '@singularsystems/neo-core';
import ShareTransactionLookup from './ShareTransactionLookup';
import TransactionRequestLookup from './TransactionRequestLookup';

export default class CreateTransactionResult extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.ChildObject(ShareTransactionLookup)
    public shareTransactionLookup: ShareTransactionLookup | null = null;

    @Attributes.ChildObject(TransactionRequestLookup)
    public pendingRequest: TransactionRequestLookup | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public newEndDate: Date | null = null;

    public unAuthoriseInvestment: boolean = true;

    // Client only properties / methods
}